import {
  HTTP_AP_ListCases_ForOpportunitiesTable_Request_Filter,
  HTTP_AP_ListCases_ForOpportunitiesTable_Request_Sort,
} from '@api-new/caseservice';
import { ENUM_AdvisorUserPermissionLevel } from '@api-new/common';
import { OpportunityTableRowModel } from '@platform/case/models/opportunity-table-row.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { AdjustedNetworkFilterModel } from '@shared/models/adjusted-network-filter.model';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const opportunityTableFilterDefaults: AdjustedNetworkFilterModel<HTTP_AP_ListCases_ForOpportunitiesTable_Request_Filter> = {
  createdAt: null,
  clientUserDisplayNameOrEmail: '',
  networkIds: [],
  companyIds: [],
  advisorUserDisplayNameOrEmail: '',
  mortgageExpiryTypes: null,
  saving: {
    min: null,
    max: null,
  },
  loanAmount: {
    min: null,
    max: null,
  },
};

export const opportunityTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
): TableRowDefinitionModel<OpportunityTableRowModel, HTTP_AP_ListCases_ForOpportunitiesTable_Request_Sort>[] => [
  {
    columnLabel: 'Client name',
    columnKey: 'clientUserDisplayName',
    sortKey: 'byClientUserDisplayName',
    type: RowDefinitionTypeEnum.FullnameShort,
    width: {
      min: '200px',
      max: '200px',
    },
    isFrozen: true,
  },
  {
    columnLabel: 'Id',
    columnKey: 'id',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'company',
    columnKey: 'companyTradingName',
    type: RowDefinitionTypeEnum.Text,
    sortKey: 'byCompanyTradingName',
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.CaseRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_COMPANY,
      },
    ]),
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'PED',
    columnKey: 'productEndDate',
    sortKey: 'byProductEndDate',
    type: RowDefinitionTypeEnum.Date,
    width: {
      min: '125px',
      max: '125px',
    },
  },
  {
    columnLabel: 'Expiry type',
    columnKey: 'mortgageExpiryTypeMapped',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '100px',
      max: '100px',
    },
  },
  {
    columnLabel: 'Adviser',
    columnKey: 'advisorUserDisplayName',
    type: RowDefinitionTypeEnum.FullnameInitials,
    sortKey: 'byAdvisorUserDisplayName',
    width: {
      min: '85px',
      max: '85px',
    },
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.CaseRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_DIRECT,
      },
    ]),
  },
  {
    columnLabel: 'Loan amount',
    columnKey: 'loanAmount',
    sortKey: 'byLoanAmount',
    type: RowDefinitionTypeEnum.Currency,
    width: {
      min: '125px',
      max: '125px',
    },
  },
  {
    columnLabel: 'Saving',
    columnKey: 'saving',
    sortKey: 'bySaving',
    type: RowDefinitionTypeEnum.Currency,
    width: {
      min: '125px',
      max: '125px',
    },
  },
  {
    columnLabel: 'Address',
    columnKey: 'address',
    type: RowDefinitionTypeEnum.Text,
    width: {
      min: '300px',
      max: '300px',
    },
  },
  {
    columnLabel: 'Current lender',
    columnKey: 'lenderId',
    type: RowDefinitionTypeEnum.LenderLogo,
    width: {
      min: '150px',
      max: '150px',
    },
  },
  {
    columnLabel: 'Created',
    columnKey: 'createdAt',
    type: RowDefinitionTypeEnum.DateTimeSince,
    sortKey: 'byCreatedAt',
    width: {
      min: '125px',
      max: '125px',
    },
  },
];
